import React from "react";
import PageTop from "../../common/PageTop/PageTop";
import Header from "../../common/Header/Header";
import Footer from "../../common/Footer/Footer";
import Details from "./Details/Details";
import EnquiryForm from "./EnquiryForm/EnquiryForm";
import Nav from "../Home/Nav/Nav";
import aboutimage from '../../../assets/images/ogcontact.jpg'

const Contact = () => {
  return (
    <>
      <Nav />
      <PageTop title={'Contact'} image={aboutimage}/>
      <Details />
      <EnquiryForm />
      <div
        style={{
          width: "100%",
        }}
      >

        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2488.5255931247725!2d-0.2128175191295306!3d51.41177105535276!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487608bfadf8f881%3A0x98e8528ea36395b4!2s265-269%20Kingston%20Rd%2C%20London%20SW19%203NW%2C%20UK!5e0!3m2!1sen!2sin!4v1737650395229!5m2!1sen!2sin"
          width="100%"
          height="450"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
